import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { siteConfig } from "@/mocks/siteConfig";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  const navLinks = [
    { name: "首页", path: "/" },
    { name: "分类", path: "/category/tutorial" },
    { name: "关于我们", path: "/about" },
  ];

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-white/95 backdrop-blur-md border-b border-black/5"
          : "bg-transparent"
      }`}
    >
      <div className="w-full px-6 md:px-10">
        <div className="flex items-center justify-between h-16">
          <Link
            to="/"
            className="flex items-center gap-2 text-xl font-bold text-foreground-950 whitespace-nowrap"
          >
            <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-foreground-950 text-white text-sm font-bold">
              M
            </span>
            {siteConfig.name}
          </Link>

          <div className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`text-sm font-medium transition-colors duration-200 whitespace-nowrap ${
                  location.pathname === link.path
                    ? "text-foreground-950"
                    : "text-foreground-600 hover:text-foreground-950"
                }`}
              >
                {link.name}
              </Link>
            ))}
            <a
              href={siteConfig.url}
              className="px-5 py-2 text-sm font-medium rounded-full bg-foreground-950 text-white hover:bg-foreground-800 transition-colors duration-200 whitespace-nowrap cursor-pointer"
            >
              立即体验
            </a>
          </div>

          <button
            className="md:hidden w-10 h-10 flex items-center justify-center rounded-lg hover:bg-black/5 transition-colors cursor-pointer"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="菜单"
          >
            <i
              className={`text-xl transition-transform duration-200 ${
                mobileOpen ? "ri-close-line" : "ri-menu-line"
              }`}
            />
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-white border-t border-black/5 shadow-lg">
          <div className="px-6 py-4 flex flex-col gap-4">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`text-sm font-medium transition-colors duration-200 whitespace-nowrap ${
                  location.pathname === link.path
                    ? "text-foreground-950"
                    : "text-foreground-600"
                }`}
              >
                {link.name}
              </Link>
            ))}
            <a
              href={siteConfig.url}
              className="px-5 py-2 text-sm font-medium rounded-full bg-foreground-950 text-white text-center whitespace-nowrap cursor-pointer"
            >
              立即体验
            </a>
          </div>
        </div>
      )}
    </nav>
  );
}